var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.tableSmall ? 'm-0' : (_vm.small ? 'm-1' : 'm-3')},[_c('div',{style:(_vm.imagesTool.avatar(_vm.src, _vm.tableSmall ? 2 : (_vm.small ? 2.5 : 10.6)))})])])}
var staticRenderFns = []

export { render, staticRenderFns }